import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { InvoiceArticle } from 'src/modules/invoice/models/invoiceArticle';
import { InvoiceArticleRequest } from 'src/modules/invoice/models/invoiceArticleRequest';
import { ArticleRegisterSearchFilter } from 'src/modules/invoice/models/articleRegisterSearchFilter';

const controller = 'InvoiceArticle';

export const getAllInvoiceArticle = (filter: ArticleRegisterSearchFilter) => {
  return AxiosInstance.get<PagedResult<InvoiceArticle>>(`${controller}`, { params: filter });
};

export const getInvoiceArticleById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<InvoiceArticle>(endpoint);
};

export const createInvoiceArticle = (data: InvoiceArticleRequest) => {
  return AxiosInstance.post<InvoiceArticleRequest>(controller, data);
};

export const updateInvoiceArticle = (article: InvoiceArticleRequest) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<InvoiceArticleRequest>(endpoint, article);
};

export const deleteInvoiceArticle = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
